exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.effects[data-v-0956977e] {\n  background-color: #E7FCFD;\n  padding-bottom: 80px;\n}\n.effect-card-container[data-v-0956977e] {\n  width: 95%;\n  margin: auto;\n}\n.margin-top[data-v-0956977e] {\n  margin: 80px auto 0 !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0956977e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/LP/Effects.vue
// module id = Cioi
// module chunks = 0